package com.hyperether.goodjob.scenes.addNew

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.foundation.text.selection.SelectionContainer
import androidx.compose.material.AlertDialog
import androidx.compose.material.Checkbox
import androidx.compose.material.DropdownMenu
import androidx.compose.material.Icon
import androidx.compose.material.Switch
import androidx.compose.material.SwitchDefaults
import androidx.compose.material.Text
import androidx.compose.material.TextButton
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.DropdownMenuItem
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.OutlinedTextFieldDefaults
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.draw.shadow
import androidx.compose.ui.focus.FocusDirection
import androidx.compose.ui.focus.FocusManager
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.layout.onGloballyPositioned
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.platform.LocalFocusManager
import androidx.compose.ui.text.SpanStyle
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.buildAnnotatedString
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.text.withStyle
import androidx.compose.ui.unit.toSize
import androidx.compose.ui.window.Dialog
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.getPlatformChecker
import com.hyperether.goodjob.is4K
import com.hyperether.goodjob.models.Contact
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.models.Step
import com.hyperether.goodjob.models.Team
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add_step
import com.hyperether.goodjob.resources.calendar__1_
import com.hyperether.goodjob.resources.cancel
import com.hyperether.goodjob.resources.clear
import com.hyperether.goodjob.resources.clock_small
import com.hyperether.goodjob.resources.continue_with_next_step
import com.hyperether.goodjob.resources.describe_the_process
import com.hyperether.goodjob.resources.done_selecting_dates
import com.hyperether.goodjob.resources.dropdown_arrow
import com.hyperether.goodjob.resources.enter_step_title
import com.hyperether.goodjob.resources.enter_time
import com.hyperether.goodjob.resources.estimated_duration
import com.hyperether.goodjob.resources.hour
import com.hyperether.goodjob.resources.minute
import com.hyperether.goodjob.resources.ok
import com.hyperether.goodjob.resources.save_changes
import com.hyperether.goodjob.resources.select_dates
import com.hyperether.goodjob.resources.select_skill
import com.hyperether.goodjob.resources.select_team
import com.hyperether.goodjob.resources.sort_by
import com.hyperether.goodjob.resources.step
import com.hyperether.goodjob.resources.step_description
import com.hyperether.goodjob.resources.step_title
import com.hyperether.goodjob.resources.trash
import com.hyperether.goodjob.scenes.components.TrailingDropdownIconButton
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.noRippleClickable
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.scenes.register.AppInputField
import com.hyperether.goodjob.scenes.register.EstimatedDurationInputField
import com.hyperether.goodjob.scenes.register.FilledButtonHeader
import com.hyperether.goodjob.theme.AddEmployeeInputColor
import com.hyperether.goodjob.theme.BlueApp
import com.hyperether.goodjob.theme.EmployeeDetailsText
import com.hyperether.goodjob.theme.HeaderText
import com.hyperether.goodjob.theme.InputBorderColor
import com.hyperether.goodjob.theme.InputIconColor
import com.hyperether.goodjob.theme.RegisterBorder
import com.hyperether.goodjob.theme.TextColor
import com.hyperether.goodjob.util.Constants
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.resources.stringResource
import io.wojciechosak.calendar.config.SelectionMode
import io.wojciechosak.calendar.config.rememberCalendarState
import io.wojciechosak.calendar.range.RangeConfig
import io.wojciechosak.calendar.range.UnderlineIllustrator
import io.wojciechosak.calendar.utils.Pallete
import io.wojciechosak.calendar.view.VerticalCalendarView
import kotlinx.datetime.Clock
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.painterResource

@Composable
fun NoteInputField(
    text: MutableState<String>,
    label: String,
    placeholder: String,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
) {
    Box(
        modifier = modifier
            .fillMaxWidth()
            .padding(top = 10.toScaleDp())
    ) {
        OutlinedTextField(
            modifier = Modifier.fillMaxWidth(),
            value = text.value,
            onValueChange = { newValue ->
                text.value = newValue
            },
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            label = {
                androidx.compose.material3.Text(
                    text = label,
                    fontSize = 14.toScaleSp(),
                    color = if (enabled) TextColor else Color.Gray,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            },
            placeholder = {
                androidx.compose.material3.Text(
                    text = placeholder,
                    fontSize = 14.toScaleSp(),
                    color = Color.LightGray,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            },
            enabled = enabled,
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                unfocusedBorderColor = InputBorderColor,
                disabledTextColor = TextColor,
                focusedBorderColor = BlueApp,
                cursorColor = BlueApp
            ),
        )
    }
}

@Composable
fun AboutContactDropdown(
    text: MutableState<String>,
    label: String? = null,
    placeholder: String,
    dropdownItems: List<Contact>,
    onContactSelected: (String) -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    var textFieldSize = remember { mutableStateOf(Size.Zero) }
    val scrollState = rememberScrollState()

    Box(
        modifier = if (!getPlatformChecker().isMobile() && is4K()) modifier
            .fillMaxWidth()
            .height(45.toScaleDp())
            .noRippleClickable {
                expanded = !expanded
            } else modifier
            .fillMaxWidth()
            .noRippleClickable {
                expanded = !expanded
            }
    ) {
        OutlinedTextField(
            value = text.value,
            onValueChange = { text.value = it },
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            label = label?.let {
                { Text(label, fontSize = 14.toScaleSp(), color = TextColor) }
            },
            placeholder = { Text(placeholder, fontSize = 14.toScaleSp(), color = Color.LightGray) },
            singleLine = true,
            modifier = Modifier
                .fillMaxSize()
                .onGloballyPositioned { coordinates ->
                    textFieldSize.value = coordinates.size.toSize()
                },
            trailingIcon = {
                TrailingDropdownIconButton(onClick = { expanded = !expanded })
            },
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                unfocusedBorderColor = InputBorderColor,
                disabledTextColor = TextColor,
                focusedBorderColor = BlueApp,
                cursorColor = BlueApp
            ),
            enabled = false
        )

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = Modifier
                .width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
                .heightIn(max = 280.toScaleDp())
//                .verticalScroll(scrollState)
                .verticalScrollbar(scrollState)
                .disableMouseDragScrollOnWeb()
        ) {
            dropdownItems.forEach { item ->
                DropdownMenuItem(
                    modifier = Modifier.height(45.toScaleDp())
                        .pointerHoverIcon(PointerIcon.Hand),
                    onClick = {
                        text.value = item.name.orEmpty()
                        item.id?.let { onContactSelected(it) }
                        expanded = false
                    },
                    text = {
                        DisableSelection {
                            Text(
                                text = item.name.orEmpty(),
                                maxLines = 2,
                                fontSize = 14.toScaleSp(),
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                )
            }
        }
    }
}

@Composable
fun AboutSiteDropdown(
    text: MutableState<String>,
    label: String,
    placeholder: String,
    dropdownItems: List<Site>,
    onSiteSelected: (Site) -> Unit,
    modifier: Modifier = Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    var textFieldSize = remember { mutableStateOf(Size.Zero) }

    if (dropdownItems.size == 1) {
        val singleSite = dropdownItems.first()
        text.value = singleSite.siteName.toString()
        onSiteSelected(singleSite)
    }

    val showDropdown = dropdownItems.size > 1

    Box(
        modifier = if (!getPlatformChecker().isMobile() && is4K()) modifier
            .fillMaxWidth()
            .height(45.toScaleDp())
            .then(if (showDropdown) Modifier.noRippleClickable {
                expanded = !expanded
            } else Modifier) else modifier
            .fillMaxWidth()
            .then(if (showDropdown) Modifier.noRippleClickable {
                expanded = !expanded
            } else Modifier)
    ) {
        OutlinedTextField(
            value = text.value,
            onValueChange = {
                text.value = ""
                text.value = it
            },
            singleLine = true,
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            label = { Text(label, fontSize = 14.toScaleSp(), color = TextColor) },
            placeholder = { Text(placeholder, fontSize = 14.toScaleSp(), color = Color.LightGray) },
            modifier = Modifier
                .fillMaxSize()
                .onGloballyPositioned { coordinates ->
                    textFieldSize.value = coordinates.size.toSize()
                },
            trailingIcon = {
                if (showDropdown) {
                    TrailingDropdownIconButton(onClick = { expanded = !expanded })
                }
            },
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                unfocusedBorderColor = InputBorderColor,
                disabledTextColor = TextColor,
                focusedBorderColor = BlueApp,
                cursorColor = BlueApp
            ),
            enabled = false
        )

        if (showDropdown) {
            if (expanded) {
                text.value = ""
            }
            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
            ) {
                dropdownItems.forEach { item ->
                    DropdownMenuItem(
                        modifier = Modifier.height(45.toScaleDp())
                            .pointerHoverIcon(PointerIcon.Hand),
                        onClick = {
                            text.value = item.siteName.toString()
                            onSiteSelected(item)
                            expanded = false
                        }, text = {
                            DisableSelection {
                                Text(
                                    item.siteName.toString(),
                                    maxLines = 2,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        })
                }
            }
        }
    }
}

@Composable
fun CustomTimePicker(
    time: String,
    onTimeSelected: (String) -> Unit,
    onDismiss: () -> Unit,
    defaultTime: String = "08:00",
    showClear: Boolean = false
) {
    val timeValue = if (time.contains(":")) time else defaultTime

    var hour by remember { mutableStateOf(timeValue.split(":")[0]) }
    var minute by remember { mutableStateOf(timeValue.split(":")[1]) }

    val hourFocusRequester = remember { FocusRequester() }
    val minuteFocusRequester = remember { FocusRequester() }

    var isHourFocused by remember { mutableStateOf(false) }
    var isMinuteFocused by remember { mutableStateOf(false) }

    val hourInt = hour.toIntOrNull()
    val minuteInt = minute.toIntOrNull()

    val isValidHour = hour.length == 2 && hourInt in 0..23
    val isValidMinute = minute.length == 2 && minuteInt in 0..59
    val isValidTime = isValidHour && isValidMinute

    AlertDialog(
        onDismissRequest = onDismiss,
        title = {
            Column {
                Text(
                    text = stringResource(Res.string.enter_time),
                    modifier = Modifier.padding(start = 8.toScaleDp()),
                    color = Color.Gray,
                    fontWeight = FontWeight.W500,
                    fontSize = 12.toScaleSp()
                )
                Text(text = "", lineHeight = 5.toScaleSp())
            }
        },
        buttons = {
            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(8.toScaleDp()),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Icon(
                        painter = painterResource(Res.drawable.clock_small),
                        contentDescription = "Time Icon",
                        modifier = Modifier
                            .size(24.toScaleDp())
                    )

                    if (showClear) {
                        TextButton(
                            onClick = { onTimeSelected("") },
                            modifier = Modifier.pointerHoverIcon(PointerIcon.Hand)
                                .offset(x = 16.toScaleDp())
                        ) {
                            Text(
                                text = stringResource(Res.string.clear),
                                color = Color.Red,
                                fontSize = 14.toScaleSp()
                            )
                        }
                    }
                }
                Row {
                    TextButton(
                        onClick = onDismiss,
                        modifier = Modifier.pointerHoverIcon(PointerIcon.Hand)
                    ) {
                        DisableSelection {
                            Text(
                                text = stringResource(Res.string.cancel),
                                color = Color.Red,
                                fontSize = 14.toScaleSp()
                            )
                        }
                    }
                    TextButton(
                        enabled = isValidTime,
                        onClick = {
                            val formatted = "${hourInt!!.toString().padStart(2, '0')}:${
                                minuteInt!!.toString().padStart(2, '0')
                            }"
                            onTimeSelected(formatted)
                        },
                        modifier = Modifier.pointerHoverIcon(PointerIcon.Hand)
                    ) {
                        Text(
                            text = stringResource(Res.string.ok),
                            color = if (isValidTime) BlueApp else Color.LightGray,
                            fontSize = 14.toScaleSp()
                        )
                    }
                }
            }
        },
        text = {
            Column(
                modifier = Modifier.padding(8.toScaleDp()),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Row(
                    verticalAlignment = Alignment.CenterVertically,
                    modifier = Modifier.fillMaxWidth().height(75.toScaleDp())
                ) {
                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        modifier = Modifier.weight(1f)
                    ) {
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .height(48.toScaleDp())
                                .focusRequester(hourFocusRequester)
                                .onFocusChanged { focusState ->
                                    isHourFocused = focusState.isFocused
                                }
                                .background(Color(0xFFE9F1FF), RoundedCornerShape(8.toScaleDp()))
                                .border(
                                    width = if (isHourFocused) 2.toScaleDp() else 0.toScaleDp(),
                                    color = if (isHourFocused) BlueApp else Color.Transparent,
                                    shape = RoundedCornerShape(8.toScaleDp())
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            BasicTextField(
                                value = hour,
                                onValueChange = {
                                    if (it.length <= 2 && it.all(Char::isDigit) && isHourInputValid(
                                            it
                                        )
                                    ) {
                                        hour = it
                                        if (hour.length == 2 && isHourInputValid(hour)) {
                                            minuteFocusRequester.requestFocus()
                                        }
                                    }
                                },
                                keyboardOptions = KeyboardOptions.Default.copy(keyboardType = KeyboardType.Number),
                                singleLine = true,
                                textStyle = TextStyle(
                                    fontSize = 28.toScaleSp(),
                                    color = BlueApp,
                                    lineHeight = 30.toScaleSp(),
                                    textAlign = TextAlign.Center
                                ),
                                decorationBox = { innerTextField ->
                                    Box(
                                        modifier = Modifier.fillMaxSize(),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        innerTextField()
                                    }
                                }
                            )
                        }

                        Text(
                            stringResource(Res.string.hour),
                            color = Color.Gray,
                            fontSize = 12.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            modifier = Modifier.align(Alignment.Start)
                        )
                    }

                    Text(
                        text = ":",
                        fontSize = 40.toScaleSp(),
                        color = Color.Black,
                        modifier = Modifier.padding(bottom = 30.toScaleDp())
                    )

                    Column(
                        horizontalAlignment = Alignment.CenterHorizontally,
                        modifier = Modifier.weight(1f)
                    ) {
                        Box(
                            modifier = Modifier
                                .weight(1f)
                                .focusRequester(minuteFocusRequester)
                                .onFocusChanged { focusState ->
                                    isMinuteFocused = focusState.isFocused
                                }
                                .background(Color(0xFFE9F1FF), RoundedCornerShape(8.toScaleDp()))
                                .border(
                                    width = if (isMinuteFocused) 2.toScaleDp() else 0.toScaleDp(),
                                    color = if (isMinuteFocused) BlueApp else Color.Transparent,
                                    shape = boxCornerShape()
                                ),
                            contentAlignment = Alignment.Center
                        ) {
                            BasicTextField(
                                value = minute,
                                onValueChange = {
                                    if (it.length <= 2 && it.all(Char::isDigit) && isMinuteInputValid(
                                            it
                                        )
                                    ) {
                                        minute = it
                                    }
                                },
                                keyboardOptions = KeyboardOptions.Default.copy(keyboardType = KeyboardType.Number),
                                singleLine = true,
                                textStyle = TextStyle(
                                    fontSize = 28.toScaleSp(),
                                    color = BlueApp,
                                    lineHeight = 30.toScaleSp(),
                                    textAlign = TextAlign.Center
                                ),
                                decorationBox = { innerTextField ->
                                    Box(
                                        modifier = Modifier.fillMaxSize(),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        innerTextField()
                                    }
                                }
                            )
                        }
                        Text(
                            stringResource(Res.string.minute),
                            color = Color.Gray,
                            fontSize = 12.toScaleSp(),
                            fontWeight = FontWeight.W400,
                            modifier = Modifier.align(Alignment.Start)
                        )
                    }
                }
            }
        }
    )
}

private fun isHourInputValid(input: String): Boolean {
    return input.isEmpty() || when (input.length) {
        1 -> input[0] in '0'..'2'
        2 -> {
            val first = input[0]
            val second = input[1]
            when (first) {
                '0', '1' -> second in '0'..'9'
                '2' -> second in '0'..'3'
                else -> false
            }
        }

        else -> false
    }
}

private fun isMinuteInputValid(input: String): Boolean {
    return input.isEmpty() || when (input.length) {
        1 -> input[0] in '0'..'5'
        2 -> input[0] in '0'..'5' && input[1] in '0'..'9'
        else -> false
    }
}

@Composable
fun StepInputFields(steps: MutableList<StepData>) {

    Column(
        modifier = Modifier
            .fillMaxWidth()
    ) {
        steps.forEachIndexed { index, step ->
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .shadow(2.toScaleDp(), shape = RoundedCornerShape(7.toScaleDp()))
                    .clip(RoundedCornerShape(7.toScaleDp()))
                    .background(Color.White)
                    .padding(16.toScaleDp())
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Text(
                        text = "${index + 1}. ${stringResource(Res.string.step)}",
                        fontSize = 18.toScaleSp(),
                        color = Color.Black,
                        modifier = Modifier.weight(1f)
                    )
                    DisableSelection {
                        Image(
                            painter = painterResource(Res.drawable.trash),
                            contentDescription = null,
                            modifier = Modifier.clickableWithPointer {
                                steps.removeAt(index)
                            }
                                .size(20.toScaleDp())
                        )
                    }
                }
                AppInputField(
                    step.title,
                    "${index + 1} ${stringResource(Res.string.step_title)}",
                    placeholder = stringResource(Res.string.enter_step_title),
                    isMaxLinesDefined = false
                )
                AppInputField(
                    step.description,
                    "${index + 1} ${stringResource(Res.string.step_description)}",
                    placeholder = stringResource(Res.string.describe_the_process),
                    isMaxLinesDefined = false
                )
                EstimatedDurationInputField(
                    step.estimation,
                    stringResource(Res.string.estimated_duration),
                    placeholder = "30 min"
                )
            }

            Spacer(modifier = Modifier.height(10.toScaleDp()))
        }

        DisableSelection {
            Text(
                text = "+ ${stringResource(Res.string.continue_with_next_step)}",
                fontSize = 16.toScaleSp(),
                color = BlueApp,
                fontWeight = FontWeight.W700,
                textAlign = TextAlign.Center,
                modifier = Modifier
                    .clickableWithPointer {
                        steps.add(StepData())
                    }
                    .padding(8.toScaleDp())
            )
        }
    }
}

@Composable
fun StepInputFields(addStep: (Step) -> Unit) {
    var step by remember { mutableStateOf(StepData()) }
    var hide by remember { mutableStateOf(true) }
    if (hide)
        Text(
            text = "+ ${stringResource(Res.string.add_step)}",
            fontSize = 16.toScaleSp(),
            color = BlueApp,
            fontWeight = FontWeight.W700,
            textAlign = TextAlign.Center,
            modifier = Modifier
                .clickableWithPointer {
                    hide = false
                }
                .padding(start = 8.toScaleDp())
        ) else
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .shadow(2.toScaleDp(), shape = RoundedCornerShape(7.toScaleDp()))
                    .clip(RoundedCornerShape(7.toScaleDp()))
                    .background(Color.White)
                    .padding(16.toScaleDp())
            ) {
                AppInputField(
                    step.title,
                    "${stringResource(Res.string.step_title)}",
                    placeholder = stringResource(Res.string.enter_step_title),
                    isMaxLinesDefined = false
                )
                AppInputField(
                    step.description,
                    "${stringResource(Res.string.step_description)}",
                    placeholder = stringResource(Res.string.describe_the_process),
                    isMaxLinesDefined = false
                )
                EstimatedDurationInputField(
                    step.estimation,
                    stringResource(Res.string.estimated_duration),
                    placeholder = "30 min"
                )
            }

            DisableSelection {
                Text(
                    text = stringResource(Res.string.save_changes),
                    fontSize = 16.toScaleSp(),
                    color = BlueApp,
                    fontWeight = FontWeight.W700,
                    textAlign = TextAlign.Center,
                    modifier = Modifier
                        .clickableWithPointer {
                            addStep(
                                Step(
                                    step.title.value,
                                    step.description.value,
                                    step.estimation.value.toIntOrNull() ?: 0,
                                    step.stepStatus.value
                                )
                            )
                            if (step.title.value.isNotEmpty()) {
                                hide = true
                                step = StepData()
                            }
                        }
                        .padding(16.toScaleDp())
                )
            }
        }
}

@Composable
fun StepInputFieldsWeb(addStep: (Step) -> Unit) {
    var step by remember { mutableStateOf(StepData()) }
    var hide by remember { mutableStateOf(true) }
    if (hide)
        FilledButtonHeader(
            {
                hide = false
            }, isEnabled = true,
            text = stringResource(Res.string.add_step),
            modifier = Modifier.padding(bottom = 16f.toScaleDp())
        )
    else
        Column(
            modifier = Modifier
                .fillMaxWidth()
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .shadow(2.toScaleDp(), shape = RoundedCornerShape(7.toScaleDp()))
                    .clip(RoundedCornerShape(7.toScaleDp()))
                    .background(Color.White)
                    .padding(16.toScaleDp())
            ) {
                AppInputField(
                    step.title,
                    "${stringResource(Res.string.step_title)}",
                    placeholder = stringResource(Res.string.enter_step_title),
                    isMaxLinesDefined = false
                )
                AppInputField(
                    step.description,
                    "${stringResource(Res.string.step_description)}",
                    placeholder = stringResource(Res.string.describe_the_process),
                    isMaxLinesDefined = false
                )
                EstimatedDurationInputField(
                    step.estimation,
                    stringResource(Res.string.estimated_duration),
                    placeholder = "30 min"
                )
            }

            DisableSelection {
                Text(
                    text = stringResource(Res.string.save_changes),
                    fontSize = 16.toScaleSp(),
                    color = BlueApp,
                    fontWeight = FontWeight.W700,
                    textAlign = TextAlign.Center,
                    modifier = Modifier
                        .clickableWithPointer {
                            addStep(
                                Step(
                                    step.title.value,
                                    step.description.value,
                                    step.estimation.value.toIntOrNull() ?: 0,
                                    step.stepStatus.value
                                )
                            )
                            if (step.title.value.isNotEmpty()) {
                                hide = true
                                step = StepData()
                            }
                        }
                        .padding(16.toScaleDp())
                )
            }
        }
}

data class StepData(
    val title: MutableState<String> = mutableStateOf(""),
    val description: MutableState<String> = mutableStateOf(""),
    val estimation: MutableState<String> = mutableStateOf(""),
    val stepStatus: MutableState<String> = mutableStateOf(Constants.STEP_STATUS_PENDING)
)

@Composable
fun CustomCalendarView(
    isMultiDay: Boolean,
    selectionMode: SelectionMode = SelectionMode.Single,
    startDate: LocalDate = Clock.System.todayIn(TimeZone.currentSystemDefault()),
    minDate: LocalDate? = null,
    onDismiss: () -> Unit,
    onDateSelect: (List<LocalDate>) -> Unit,
    showErrorMessage: () -> Unit
) {

    Dialog(
        onDismissRequest = { onDismiss() },
    ) {
        val selectedDates = remember { mutableStateListOf<LocalDate>() }

        Column(
            modifier = Modifier
                .background(Color.White),
        ) {
            VerticalCalendarView(
                startDate = startDate,
                modifier = Modifier.height(400.toScaleDp())
            ) { monthOffset ->
                RangeCalendarView(
                    config = rememberCalendarState(
                        startDate = startDate,
                        monthOffset = monthOffset,
                        selectedDates = selectedDates,
                    ),
                    selectionMode = selectionMode,
                    onDateSelected = { dates ->
                        val validDates = dates.filter { minDate == null || it >= minDate }
                        if (validDates.isNotEmpty()) {
                            selectedDates.clear()
                            selectedDates.addAll(validDates)
                            onDateSelect(validDates)
                            if (selectionMode == SelectionMode.Single)
                                onDismiss()
                        } else {
                            showErrorMessage()
                        }
                    },
                    rangeConfig = RangeConfig(rangeIllustrator = UnderlineIllustrator(Pallete.LightGreen)),
                )
            }
            if (selectionMode != SelectionMode.Single) {
                Box(
                    modifier = Modifier.fillMaxWidth().padding(8.toScaleDp()),
                    contentAlignment = Alignment.CenterEnd
                ) {
                    TextButton(
                        onClick = {
                            onDateSelect(selectedDates)
                            onDismiss()
                        },
                    ) {
                        Text(
                            stringResource(Res.string.done_selecting_dates),
                            fontSize = 14.toScaleSp(),
                            fontWeight = FontWeight.W500,
                            color = BlueApp
                        )
                    }
                }
            }
//            if (selectedDates.size == 2) {
//                androidx.compose.material3.Text("From:\n${selectedDates.last()} to ${selectedDates.first()}")
//            }
        }
    }
}

private fun determineSelectionMode(selectedDates: List<LocalDate>): SelectionMode {
    return when {
        isConsecutiveDates(selectedDates) -> SelectionMode.Range
        else -> SelectionMode.Multiply(30)
    }
}

private fun isConsecutiveDates(dates: List<LocalDate>): Boolean {
    if (dates.size < 2) return false
    val sortedDates = dates.sorted()
    return sortedDates.zipWithNext().all { (current, next) ->
        next == current.plus(1, DateTimeUnit.DAY)
    }
}

@Composable
fun OutlinedCalendarInput(
    onClick: () -> Unit,
    input: MutableState<String>,
    modifier: Modifier = Modifier,
    label: String? = null,
    placeholder: String = stringResource(Res.string.select_dates)
) {
    OutlinedTextField(
        value = input.value,
        onValueChange = {
            input.value = it
        },
        singleLine = true,
        textStyle = TextStyle(fontSize = 14.toScaleSp()),
        label = label?.let {
            {
                Text(label, fontSize = 14.toScaleSp(), color = TextColor)
            }
        },
        placeholder = { Text(placeholder, fontSize = 14.toScaleSp(), color = TextColor) },
        modifier = modifier.fillMaxWidth()
            .clickableWithPointer {
                onClick()
            },
        trailingIcon = {
            Icon(
                painter = painterResource(Res.drawable.calendar__1_),
                contentDescription = "",
                modifier = Modifier.padding(end = 10.toScaleDp()).size(20.toScaleDp()),
                tint = InputIconColor
            )
        },
        colors = OutlinedTextFieldDefaults.colors(
            disabledBorderColor = InputBorderColor,
            unfocusedBorderColor = InputBorderColor,
            disabledTextColor = TextColor
        ),
        enabled = false
    )
}

@Composable
fun InputCityCountryZipWeb(
    painterResource: DrawableResource,
    labelText: String,
    placeholderCity: String,
    placeholderCountry: String,
    placeholderZip: String,
    inputValueCity: String,
    inputValueCountry: String,
    inputValueZip: String,
    onCityChange: (String) -> Unit,
    onCountryChange: (String) -> Unit,
    onZipChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    textColor: Color = EmployeeDetailsText,
    placeholderColor: Color = AddEmployeeInputColor,
    focusManager: FocusManager
) {
    Row(
        modifier = modifier
            .onPreviewKeyEvent {
                when {
                    KeyEventType.KeyUp == it.type && Key.Tab == it.key -> {
                        focusManager.moveFocus(FocusDirection.Next)
                        true
                    }

                    else -> false
                }
            }
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(8.toScaleDp()) // Adds spacing between fields
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            Image(
                painter = painterResource(painterResource),
                contentDescription = null
            )
            Text(
                text = labelText,
                color = textColor,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 20.toScaleDp())
            )
        }

        OutlinedTextField(
            value = inputValueCity,
            onValueChange = onCityChange,
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            placeholder = { Text(text = placeholderCity, color = placeholderColor) },
            modifier = Modifier.weight(0.8f),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = InputBorderColor,
                unfocusedBorderColor = RegisterBorder,
                disabledTextColor = TextColor
            ),
            shape = RoundedCornerShape(8.toScaleDp())
        )

        // Country Input
        OutlinedTextField(
            value = inputValueCountry,
            onValueChange = onCountryChange,
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            placeholder = { Text(text = placeholderCountry, color = placeholderColor) },
            modifier = Modifier.weight(0.8f),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = InputBorderColor,
                unfocusedBorderColor = RegisterBorder,
                disabledTextColor = TextColor
            ),
            shape = RoundedCornerShape(8.toScaleDp())
        )

        OutlinedTextField(
            value = inputValueZip,
            onValueChange = onZipChange,
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            placeholder = { Text(text = placeholderZip, color = placeholderColor) },
            modifier = Modifier.weight(0.4f),
            colors = OutlinedTextFieldDefaults.colors(
                focusedBorderColor = InputBorderColor,
                unfocusedBorderColor = RegisterBorder,
                disabledTextColor = TextColor
            ),
            shape = RoundedCornerShape(8.toScaleDp())
        )
    }
}

@Composable
fun WorkingHoursView(viewModel: AddUserViewModel) {
    LazyColumn(modifier = Modifier.fillMaxWidth().heightIn(max = 406.toScaleDp())) {
        if (viewModel.daysSchedule.isNotEmpty()) {
            items(viewModel.daysSchedule.takeIf { it.isNotEmpty() } ?: emptyList()) { daySchedule ->
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier
                            .weight(1.5f)
                            .height(58.toScaleDp())
                            .padding(top = 8.toScaleDp())
                    ) {
                        Switch(
                            modifier = Modifier
                                .scale(1.toScaleDp().value)
                                .pointerHoverIcon(PointerIcon.Hand),
                            checked = daySchedule.isChecked.value,
                            onCheckedChange = {
                                daySchedule.isChecked.value = it
                                if (!it) {
                                    daySchedule.startTime.value = "08:00"
                                    daySchedule.endTime.value = "16:00"
                                }
                            },
                            colors = SwitchDefaults.colors(
                                checkedThumbColor = BlueApp,
                                checkedTrackColor = BlueApp,
                                uncheckedThumbColor = Color.Gray,
                                uncheckedTrackColor = Color.LightGray
                            )
                        )
                        Spacer(modifier = Modifier.width(16.toScaleDp()))
                        Text(
                            text = daySchedule.getName(),
                            color = Color.DarkGray,
                            fontSize = 13.toScaleSp(),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    }

                    if (daySchedule.isChecked.value) {
                        Spacer(modifier = Modifier.width(8.toScaleDp()))

                        OutlinedButton(
                            onClick = { daySchedule.isStartTimePickerVisible.value = true },
                            border = BorderStroke(1.toScaleDp(), InputBorderColor),
                            shape = RoundedCornerShape(8.toScaleDp()),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color.White, containerColor = Color.Transparent
                            ),
                            modifier = Modifier
                                .height(58.toScaleDp())
                                .weight(1f)
                                .padding(top = 15.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand)
                        ) {
                            Text(
                                text = daySchedule.startTime.value,
                                color = Color.DarkGray,
                                fontSize = 13.toScaleSp(),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }

                        Spacer(modifier = Modifier.width(8.toScaleDp()))

                        OutlinedButton(
                            onClick = { daySchedule.isEndTimePickerVisible.value = true },
                            border = BorderStroke(1.toScaleDp(), InputBorderColor),
                            shape = RoundedCornerShape(8.toScaleDp()),
                            colors = ButtonDefaults.outlinedButtonColors(
                                contentColor = Color.White, containerColor = Color.Transparent
                            ),
                            modifier = Modifier
                                .height(58.toScaleDp())
                                .weight(1f)
                                .padding(top = 15.toScaleDp())
                                .pointerHoverIcon(PointerIcon.Hand)
                        ) {
                            Text(
                                text = daySchedule.endTime.value,
                                color = Color.DarkGray,
                                fontSize = 13.toScaleSp(),
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis
                            )
                        }
                    }
                }

                if (daySchedule.isChecked.value && daySchedule.isStartTimePickerVisible.value) {
                    CustomTimePicker(
                        time = daySchedule.startTime.value,
                        onTimeSelected = {
                            daySchedule.startTime.value = it
                            daySchedule.isStartTimePickerVisible.value = false
                        },
                        onDismiss = {
                            daySchedule.isStartTimePickerVisible.value = false
                        },
                        showClear = false
                    )
                }
                if (daySchedule.isChecked.value && daySchedule.isEndTimePickerVisible.value) {
                    CustomTimePicker(
                        time = daySchedule.endTime.value,
                        onTimeSelected = {
                            daySchedule.endTime.value = it
                            daySchedule.isEndTimePickerVisible.value = false
                        },
                        onDismiss = {
                            daySchedule.isEndTimePickerVisible.value = false
                        },
                        showClear = false
                    )
                }
            }
        }
    }
}

@Composable
fun CustomNumberInputRowUser(
    painterResource: DrawableResource,
    labelText: String,
    placeholderText: String,
    inputValue: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    textColor: Color = EmployeeDetailsText,
    placeholderColor: Color = Color.LightGray,
    focusManager: FocusManager
) {
    Row(
        modifier = modifier
            .onPreviewKeyEvent {
                when {
                    KeyEventType.KeyUp == it.type && Key.Tab == it.key -> {
                        focusManager.moveFocus(FocusDirection.Next)
                        true
                    }

                    else -> false
                }
            }
            .then(modifier)
            .fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            Box(modifier = Modifier.size(20.toScaleDp())) {
                Image(
                    modifier = Modifier.size(20.toScaleDp()),
                    painter = painterResource(painterResource),
                    contentDescription = null
                )
            }
            Text(
                text = labelText,
                color = textColor,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 20.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }
        OutlinedTextField(
            value = inputValue,
            onValueChange = { newValue ->
                if (newValue.length <= 15 && (newValue.isEmpty() || newValue.all { it.isDigit() } ||
                            (newValue.startsWith("+") && newValue.drop(1).all { it.isDigit() }))) {
                    onValueChange(newValue)
                }
            },
            textStyle = TextStyle(fontSize = 14.toScaleSp()),
            singleLine = true,
            placeholder = {
                Text(
                    text = placeholderText,
                    color = placeholderColor,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            },
            modifier = Modifier
                .height(56.toScaleDp())
                .weight(2f),
            keyboardOptions = KeyboardOptions.Default.copy(keyboardType = KeyboardType.Phone),
            colors = OutlinedTextFieldDefaults.colors(
                disabledBorderColor = InputBorderColor,
                unfocusedBorderColor = InputBorderColor,
                disabledTextColor = TextColor,
                focusedBorderColor = BlueApp,
                cursorColor = BlueApp
            ),
        )
    }
}


@Composable
fun CustomDropdownMenu(
    iconRes: DrawableResource?,
    labelText: String,
    placeholderText: String,
    items: List<String>,
    selectedValue: String,
    onValueSelected: (String) -> Unit,
    modifier: Modifier = Modifier,
    textColor: Color = EmployeeDetailsText,
    focusManager: FocusManager
) {
    var expanded by remember { mutableStateOf(false) }
    var textFieldSize = remember { mutableStateOf(Size.Zero) }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .onPreviewKeyEvent {
                when {
                    KeyEventType.KeyUp == it.type && Key.Tab == it.key -> {
                        focusManager.moveFocus(FocusDirection.Next)
                        true
                    }

                    else -> false
                }
            }
            .then(modifier),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            iconRes?.let { painterResource(it) }?.let {
                Image(
                    painter = it,
                    contentDescription = null,
                    modifier = Modifier.size(20.toScaleDp()),
                    colorFilter = ColorFilter.tint(Color.Gray)
                )
            }
            SelectionContainer {
                Text(
                    text = labelText,
                    color = textColor,
                    fontSize = 14.toScaleSp(),
                    modifier = Modifier.padding(start = 20.toScaleDp()),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
        }

        Box(
            modifier = Modifier
                .weight(2f)
        ) {
            OutlinedTextField(
                value = selectedValue,
                onValueChange = {},
                enabled = false,
                readOnly = true,
                trailingIcon = {
                    TrailingDropdownIconButton(
                        onClick = { expanded = !expanded },
                        tint = Color(0xFF676767)
                    )
                },
                textStyle = TextStyle(fontSize = 14.toScaleSp()),
                singleLine = true,
                placeholder = {
                    Text(
                        text = placeholderText,
                        fontSize = 14.toScaleSp(),
                        color = Color.LightGray,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        style = TextStyle(fontSize = 14.toScaleSp(), lineHeight = 20.toScaleSp())
                    )
                },
                modifier = Modifier
                    .fillMaxWidth()
                    .height(56.toScaleDp())
                    .onGloballyPositioned { coordinates ->
                        textFieldSize.value = coordinates.size.toSize()
                    }
                    .noRippleClickable {
                        expanded = !expanded
                    },
                colors = OutlinedTextFieldDefaults.colors(
                    disabledBorderColor = InputBorderColor,
                    unfocusedBorderColor = InputBorderColor,
                    disabledTextColor = TextColor,
                    focusedBorderColor = BlueApp,
                    cursorColor = BlueApp,
                    unfocusedPlaceholderColor = Color.LightGray
                ),
            )

            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
            ) {
                items.forEach { option ->
                    DropdownMenuItem(
                        onClick = {
                            onValueSelected(option)
                            expanded = false
                        },
                        text = {
                            Text(
                                option,
                                maxLines = 1,
                                lineHeight = 20.toScaleSp(),
                                overflow = TextOverflow.Ellipsis,
                                fontSize = 14.toScaleSp()
                            )
                        },
                        modifier = Modifier
                            .height(56.toScaleDp())
                            .pointerHoverIcon(PointerIcon.Hand)
                    )
                }
            }
        }
    }
}

@Composable
fun <T> TeamsDropdownMenu(
    iconRes: DrawableResource,
    labelText: String,
    selectedValue: T,
    modifier: Modifier = Modifier,
    textColor: Color = EmployeeDetailsText,
    itemsFromDb: List<Team>,
    focusManager: FocusManager,
    selectedTeam: Team?,
    onItemSelected: (Team) -> Unit,
    onAddNewItem: (String) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    var textFieldSize by remember { mutableStateOf(Size.Zero) }

    var text by remember { mutableStateOf(selectedTeam?.name ?: "") }

    LaunchedEffect(selectedTeam) {
        text = selectedTeam?.name ?: ""
    }

    Row(
        modifier = modifier
            .fillMaxWidth()
            .onPreviewKeyEvent {
                when {
                    KeyEventType.KeyUp == it.type && Key.Tab == it.key -> {
                        focusManager.moveFocus(FocusDirection.Next)
                        true
                    }

                    else -> false
                }
            },
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            Box(modifier = Modifier.size(20.toScaleDp())) {
                Image(
                    modifier = Modifier.size(20.toScaleDp()),
                    painter = painterResource(iconRes),
                    contentDescription = null
                )
            }
            Text(
                text = labelText,
                color = textColor,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 20.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }

        Box(
            modifier = Modifier
                .weight(2f)
                .onGloballyPositioned { coordinates ->
                    textFieldSize = coordinates.size.toSize()
                }
        ) {
            OutlinedTextField(
                value = text,
                onValueChange = { text = it },
                readOnly = false,
                modifier = Modifier
                    .height(56.toScaleDp())
                    .fillMaxWidth()
                    .clickableWithPointer { expanded = true },
                label = { Text(stringResource(Res.string.select_team), fontSize = 14.toScaleSp()) },
                trailingIcon = {
                    TrailingDropdownIconButton(
                        onClick = { expanded = !expanded },
                        tint = Color(0xFF676767)
                    )
                },
                singleLine = true,
                textStyle = TextStyle(
                    color = textColor,
                    fontSize = 14.toScaleSp()
                ),
                keyboardOptions = KeyboardOptions.Default.copy(
                    imeAction = ImeAction.Done
                ),
                keyboardActions = KeyboardActions(
                    onDone = {
                        if (text.isNotEmpty()) {
                            onAddNewItem(text)
                        }
                        focusManager.moveFocus(FocusDirection.Next)
                    }
                ),
                colors = OutlinedTextFieldDefaults.colors(
                    disabledBorderColor = InputBorderColor,
                    unfocusedBorderColor = InputBorderColor,
                    disabledTextColor = TextColor,
                    focusedBorderColor = BlueApp,
                    cursorColor = BlueApp
                )
            )

            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.width.toDp() })
            ) {
                itemsFromDb.forEach { item ->
                    DropdownMenuItem(
                        modifier = Modifier.height(56.toScaleDp()),
                        onClick = {
                            text = item.name ?: ""
                            onItemSelected(item)
                            expanded = false
                        },
                        text = {
                            Text(
                                text = item.name ?: "",
                                maxLines = 1,
                                overflow = TextOverflow.Ellipsis,
                                fontSize = 16.toScaleSp()
                            )
                        }
                    )
                }
            }
        }
    }
}


@Composable
fun <T> SkillsDropdownMenu(
    iconRes: DrawableResource,
    labelText: String,
    selectedValue: T,
    modifier: Modifier = Modifier,
    textColor: Color = EmployeeDetailsText,
    selectedItems: MutableState<List<String>>,
    onItemSelected: (List<String>) -> Unit,
    dropdownItems: MutableState<List<String>>,
    preselectedItems: MutableState<List<String>>,
    onAddNewValue: (String) -> Unit
) {
    var expanded by remember { mutableStateOf(false) }
    var selectedOption = remember { mutableStateOf(selectedValue) }
    val density = LocalDensity.current
    var textFieldSize = remember { mutableStateOf(Size.Zero) }

    val newItemText = remember { mutableStateOf("") }
    val focusManager = LocalFocusManager.current

    LaunchedEffect(preselectedItems.value) {
        preselectedItems.value.forEach { preselectedItem ->
            if (preselectedItem in dropdownItems.value && preselectedItem !in selectedItems.value) {
                selectedItems.value += preselectedItem
                onItemSelected(selectedItems.value)
            }
        }
    }


    Row(
        modifier = modifier
            .fillMaxWidth()
            .onPreviewKeyEvent {
                when {
                    KeyEventType.KeyUp == it.type && Key.Tab == it.key -> {
                        focusManager.moveFocus(FocusDirection.Next)
                        true
                    }

                    else -> false
                }
            }
            .then(modifier),
        verticalAlignment = Alignment.CenterVertically
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.weight(1f)
        ) {
            Box(modifier = Modifier.size(20.toScaleDp())) {
                Image(
                    modifier = Modifier.size(20.toScaleDp()),
                    painter = painterResource(iconRes),
                    contentDescription = null
                )
            }
            Text(
                text = labelText,
                color = textColor,
                fontSize = 14.toScaleSp(),
                modifier = Modifier.padding(start = 20.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
        }

        Box(
            modifier = Modifier
                .weight(2f)
                .clickable { expanded = true }
        ) {
            OutlinedTextField(
                value = selectedItems.value.joinToString(", ") + newItemText.value,
                onValueChange = {
                    newItemText.value = it
                },
                readOnly = selectedItems.value.isNotEmpty(),
                modifier = Modifier
                    .height(56.toScaleDp())
                    .fillMaxWidth()
                    .onGloballyPositioned { coordinates ->
                        textFieldSize.value = coordinates.size.toSize()
                    },
                label = {
                    Text(
                        stringResource(Res.string.select_skill),
                        fontSize = 14.toScaleSp()
                    )
                },
                trailingIcon = {
                    TrailingDropdownIconButton(
                        onClick = { expanded = !expanded },
                        tint = Color(0xFF676767)
                    )
                },
                singleLine = true,
                textStyle = TextStyle(
                    color = textColor,
                    fontSize = 14.toScaleSp()
                ),
                keyboardOptions = KeyboardOptions.Default.copy(
                    imeAction = ImeAction.Done
                ),
                keyboardActions = KeyboardActions(
                    onDone = {
                        if (newItemText.value.isNotBlank()) {
                            val newItem = newItemText.value
                            if (newItem !in dropdownItems.value) {
                                dropdownItems.value += newItem
                            }
                            selectedItems.value += newItem
                            newItemText.value = ""

                            onAddNewValue(newItem)
                            focusManager.moveFocus(FocusDirection.Next)
                        }
                    }
                ),
                colors = OutlinedTextFieldDefaults.colors(
                    disabledBorderColor = InputBorderColor,
                    unfocusedBorderColor = InputBorderColor,
                    disabledTextColor = TextColor,
                    focusedBorderColor = BlueApp,
                    cursorColor = BlueApp
                )
            )

            DropdownMenu(
                expanded = expanded,
                onDismissRequest = { expanded = false },
                modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
            ) {
                dropdownItems.value.forEach { item ->
                    DropdownMenuItem(
                        modifier = Modifier.height(56.toScaleDp()),
                        onClick = {
                            selectedItems.value = if (item !in selectedItems.value) {
                                selectedItems.value + item
                            } else {
                                selectedItems.value - item
                            }
                            onItemSelected(selectedItems.value)
                        },
                        text = {
                            Row(verticalAlignment = Alignment.CenterVertically) {
                                Checkbox(
                                    modifier = Modifier.scale(1.toScaleDp().value),
                                    checked = item in selectedItems.value,
                                    onCheckedChange = { isChecked ->
                                        selectedItems.value = if (isChecked) {
                                            selectedItems.value + item
                                        } else {
                                            selectedItems.value - item
                                        }
                                        onItemSelected(selectedItems.value)
                                    },
                                    colors = androidx.compose.material.CheckboxDefaults.colors(
                                        checkedColor = BlueApp,
                                        uncheckedColor = com.hyperether.goodjob.theme.Divider
                                    )
                                )
                                Spacer(modifier = Modifier.width(8.toScaleDp()))
                                Text(
                                    item,
                                    fontSize = 14.toScaleSp(),
                                    maxLines = 1,
                                    overflow = TextOverflow.Ellipsis
                                )
                            }
                        }
                    )
                }
            }
        }
    }
}


@Composable
fun <T> DropdownSortBy(
    shouldAppendSortBy: Boolean,
    placeholderColor: Color,
    items: List<T>,
    selectedValue: T,
    displayText: (T) -> String,
    textColor: Color,
    onValueSelected: (T) -> Unit,
    modifier: Modifier
) {
    var expanded by remember { mutableStateOf(false) }
    val selectedOption = remember { mutableStateOf(selectedValue) }
    var textFieldSize = remember { mutableStateOf(Size.Zero) }

    Column(
        modifier = modifier
            .height(55.toScaleDp())
            .width(180.toScaleDp())
            .border(
                width = 1.toScaleDp(),
                color = placeholderColor,
                shape = RoundedCornerShape(8.toScaleDp())
            )
            .clickableWithPointer { expanded = true }
            .padding(horizontal = 12.toScaleDp(), vertical = 8.toScaleDp())
            .onGloballyPositioned { coordinates ->
                textFieldSize.value = coordinates.size.toSize()
            },
        verticalArrangement = Arrangement.Center
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            Text(
                text = buildAnnotatedString {
                    if (shouldAppendSortBy) {
                        withStyle(
                            style = SpanStyle(
                                fontWeight = FontWeight.W400,
                                color = HeaderText
                            )
                        ) {
                            append(stringResource(Res.string.sort_by) + " ")
                        }
                    }
                    withStyle(
                        style = SpanStyle(
                            fontWeight = FontWeight.W400,
                            color = Color.Black
                        )
                    ) {
                        append(displayText(selectedOption.value))
                    }
                },
                color = if (selectedOption.value == selectedValue) placeholderColor else textColor,
                fontSize = 14.toScaleSp(),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Icon(
                painter = painterResource(Res.drawable.dropdown_arrow),
                contentDescription = null,
                tint = Color(0xFF676767),
                modifier = Modifier.padding(start = 8.toScaleDp())
            )
        }

        DropdownMenu(
            expanded = expanded,
            onDismissRequest = { expanded = false },
            modifier = Modifier.width(with(LocalDensity.current) { textFieldSize.value.width.toDp() })
        ) {
            items.forEach { option ->
                DropdownMenuItem(
                    modifier = Modifier.pointerHoverIcon(PointerIcon.Hand),
                    onClick = {
                        selectedOption.value = option
                        onValueSelected(option)
                        expanded = false
                    },
                    text = {
                        Text(
                            displayText(option),
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                    },
                )
            }
        }
    }
}

